import { takeLatest, call, select, put } from "redux-saga/effects";
import React from "react";
import { toast } from 'react-toastify';
import SVG from 'react-inlinesvg';
import { errorCircleSVG } from '../../shared/helpers/icons';
import styles from '../../shared/styles/notifications.module.scss';
import { 
    EXPORT_VEHICLES_PDF_REQUEST, 
    EXPORT_VEHICLES_EXCEL_REQUEST,
    exportVehiclesPDFSuccess,
    exportVehiclesPDFFailure,
    exportVehiclesExcelSuccess,
    exportVehiclesExcelFailure
} from "../actions/export";
import { exportVehiclesPDF, exportVehiclesExcel } from "../services/export";
import { accessTokenSelector } from "../../auth/selectors/token";

function* exportVehiclesPDFWorker({ payload: { filters } }) {
    try {
        const token = yield select(accessTokenSelector);
        const response = yield call(exportVehiclesPDF, filters, token);
        
        // Crear un blob y descargarlo
        const blob = new Blob([response.data], { 
            type: 'application/pdf' 
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `vehiculos-reporte.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        yield put(exportVehiclesPDFSuccess());
    } catch (error) {
        console.error('Error al exportar PDF:', error);
        toast.error(
            <div className={styles.customToastError}>
                <div className={styles.toastContent}>
                    <SVG src={errorCircleSVG} className={styles.toastIconError} />
                    Error al exportar el archivo PDF. Por favor, intente nuevamente.
                </div>
            </div>,
            {
                className: styles.toast,
                toastId: `export-pdf-error-${Date.now()}`
            }
        );
        yield put(exportVehiclesPDFFailure(error));
    }
}

function* exportVehiclesExcelWorker({ payload: { filters } }) {
    try {
        const token = yield select(accessTokenSelector);
        const response = yield call(exportVehiclesExcel, filters, token);
        
        // Crear un blob y descargarlo
        const blob = new Blob([response.data], { 
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `vehiculos-reporte.xlsx`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        yield put(exportVehiclesExcelSuccess());
    } catch (error) {
        console.error('Error al exportar Excel:', error);
        toast.error(
            <div className={styles.customToastError}>
                <div className={styles.toastContent}>
                    <SVG src={errorCircleSVG} className={styles.toastIconError} />
                    Error al exportar el archivo Excel. Por favor, intente nuevamente.
                </div>
            </div>,
            {
                className: styles.toast,
                toastId: `export-excel-error-${Date.now()}`
            }
        );
        yield put(exportVehiclesExcelFailure(error));
    }
}

export default [
    takeLatest(EXPORT_VEHICLES_PDF_REQUEST, exportVehiclesPDFWorker),
    takeLatest(EXPORT_VEHICLES_EXCEL_REQUEST, exportVehiclesExcelWorker)
];
